module.exports = __webpack_public_path__ + "assets/img/00.f6cca94b.png";